<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <GnbPmDataQueryLeftTree ref="gnbPmDataQueryLeftTree" @gnbPmDataQueryTreeClickEventPush="gnbPmDataQueryTreeClickEventPush" ></GnbPmDataQueryLeftTree>
    </template>
    <template v-slot:right_view>
      <GnbPmDataQueryRightList ref="gnbPmDataQueryRightList" :treeClickInfo="treeClickInfo"></GnbPmDataQueryRightList>
    </template>
  </BasicLayout>
</template>

<script>
  import BasicLayout from '../../../layouts/BasicLayout';
  import GnbPmDataQueryLeftTree from "../../../components/pmConfig/gnb/PmDataQueryForGnb/Left/GnbPmDataQueryLeftTree";
  import GnbPmDataQueryRightList from "../../../components/pmConfig/gnb/PmDataQueryForGnb/Right/GnbPmDataQueryRightList";
  export default {
    name: 'PmDataQueryForGnb',
    components: {
      BasicLayout,
      GnbPmDataQueryLeftTree,
      GnbPmDataQueryRightList
    },
    data() {
      return {
        left: {
          show: true,
          name: this.$t('Pm.gnbPmDataQuery')
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.gnbManagement')}/${this.$t('Pm.gnbPmDataQuery')}`
        },
        treeClickInfo: {}
      }
    },
    methods: {
      gnbPmDataQueryTreeClickEventPush(params){
        this.treeClickInfo = params;
      }
    }
  };
</script>

<style scoped>
</style>
